import {BaseContainerModel} from '../../base-container.model';
import { bl_cms_website_hostname_hdr_RowClass } from '../../../dbschema';

export class WebsiteHostnameContainerModel extends BaseContainerModel {
  bl_cms_website_hostname_hdr: bl_cms_website_hostname_hdr_RowClass = new bl_cms_website_hostname_hdr_RowClass();
}
